import { toast } from 'react-toastify';
import { AvailabilityResponse } from '../../../../../../../api/types/calender/avalability-slots/availability-response';
import appApi from '../../../../../../../api/app-api';
import dateUtils from '../../../../../../../utils/date-format';
import { AvailabilitySlot } from '../../../../../../../api/types/calender/avalability-slots/availability-slot';
import { selectSlotOperation } from './select-slot-operation';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';

export const getAvailabilitySlotsOperations = async (
  branchId: number,
  startDate: Date | null,
  startTime: Date | null,
  endTime: Date | null,
  iterationNumber: number,
  setLoading: (isLoading: boolean) => any,
  setAvailabilitySlots: (slots: AvailabilityResponse[]) => any,
  handleSlotSelect: (
    lectureNumber: number,
    slot: AvailabilitySlot | null,
  ) => any,
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  },
) => {
  try {
    if (!startDate) {
      toast.warn('יש לבחור תאריך התחלה');
      return;
    }

    if (!startTime || !endTime) {
      toast.warn('יש לבחור שעת התחלה וסיום');
      return;
    }

    if (startTime >= endTime) {
      toast.warn('יש לבחור זמני מפגש תקינים');
      return;
    }

    const durationMinutes = dateUtils.getDeltaInMinutes(startTime, endTime);

    if (durationMinutes < 15 || durationMinutes > 400) {
      toast.warn('ניתן ליצור שיבוץ בין 15 דקות ל 6 שעות');
      return;
    }

    setLoading(true);
    const res = await appApi.getCalendarSlots(
      branchId,
      startDate,
      iterationNumber,
      startTime,
      durationMinutes,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setLoading(false);

    if (editTimeSlot) {
      selectSlotOperation(res.data.body, editTimeSlot, handleSlotSelect);
    }

    setAvailabilitySlots(res.data.body);
  } catch (e) {
    toast.error('יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
